import { assets, stats } from "../data/siteData";

export default function Hero() {
  return (
    <section id="top" className="hero" aria-labelledby="hero-title">
      <div className="hero-media" aria-hidden="true">
        <img src={assets.heroImage} alt="" />
      </div>
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="eyebrow">Private gospel piano coaching for every level</p>
        <h1 id="hero-title">Learn Gospel Piano With Clarity At Any Level</h1>
        <p className="hero-copy">
          Personalised gospel piano coaching designed to give you clarity,
          structure, and measurable progress in your playing.
        </p>

        <div className="hero-actions">
          <a href="#book" className="button button-primary">
            Start Your Booking
          </a>
          <a href="#process" className="button button-secondary">
            See The Process
          </a>
        </div>

        <div className="hero-stats" aria-label="Coaching highlights">
          {stats.map((stat) => (
            <div key={stat.label}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
